<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        color="primary mr-5"
        dark
        v-bind="attrs"
        v-on="on"
        @click="reload"
      >
        申請
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        連携申請
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="filterName"
          placeholder="farmers ユーザー"
        ></v-text-field>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>ユーザー名</th>
                <th>住所</th>
                <th>申請先を選択</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="farmerUser in visibleFarmerUsers" :key="farmerUser.id" :class="{is_cooperated: farmerUser.is_cooperated}">
                <td>{{ farmerUser.username }}</td>
                <td>{{ farmerUser.address }}</td>
                <td>
                  <v-checkbox
                    :disabled="farmerUser.is_cooperated"
                    v-model="farmerUser.isSelected"
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          @click="dialog = false"
          dark
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          dark
          @click="clickRequestButton"
          :disabled="!isSelectedFarmerUser"
        >
          申請
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import Fuse from 'fuse.js'
import Swal from 'sweetalert2';

import router from "../../router";

let fuse; // あいまい検索に利用

export default {
  name: 'CooperationUsersDialog',
  mounted() {
    this.reload()
  },
  data() {
    return {
      dialog: false,
      visibleFarmerUsers: [],
      farmerUsers: [],
      filterName: "",
      isSelectedFarmerUser: false
    }
  },
  methods: {
    checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        this.$session.destroy();
        router.push("/auth");
      } else {
        axios.defaults.headers.common[
          "Authorization"
        ] = `JWT ${this.$session.get("token")}`;
        axios.get('/api/current_user/').then(res => {
          this.$session.set('current_user',res.data);
        }).catch(()=>{
          this.$session.destroy();
          router.push("/auth");
        });
      }
    },
    reload() {
      this.checkLoggedIn()
      // farmersユーザーの取得
      axios.get('/api/farmer_users/').then((res) => {
        this.farmerUsers = res.data
        .filter(user => {return user.is_masters_open})
        .map((obj) => {
          obj.isSelected = false
          return obj
        })
        this.visibleFarmerUsers = res.data.filter(user => {return user.is_masters_open})
        fuse = new Fuse(this.farmerUsers, {
          keys: [
            'username',
            'first_name',
            'last_name',
          ]
        })
      })
    },
    clickRequestButton() {
      const selectedUserIdList = this.farmerUsers.map(obj => {
        if(obj.isSelected === true) {
          return obj.id
        } else {
          return
        }
      }).filter(e => e)
      axios.post('/api/masters/coop_users/', {
        'farmers_user_id_list': selectedUserIdList
      }).then(() => {
        this.$emit('reload')
        this.dialog = false
      }).catch((err) => {
        const errorMessage = err.response?.data?.detail ? err.response.data.detail : '予期せぬエラーで申請に失敗しました'
        Swal.fire({
          icon: 'warning',
          title: '申請失敗',
          text: errorMessage,
          showCloseButton: true
        }).then(() => {
          this.reload()
        })
      })
    }
  },
  watch: {
    filterName(val) {
      if (val === '' || val === null) {
        this.visibleFarmerUsers = this.farmerUsers
      } else {
        this.visibleFarmerUsers = fuse.search(val).map(obj => {
          return obj.item
        })
      }
    },
    visibleFarmerUsers: {
      handler(array) {
        this.isSelectedFarmerUser = false
        array.forEach((obj) => {
          if (obj.isSelected === true) {
            this.isSelectedFarmerUser = true
          }
        })
      },
      deep: true
    },
  }
}
</script>
<style scoped>
.is_cooperated {
  color: #808080;
}
</style>
